export default {
    page_title: "Kevi | Usuarios",
    title: "Usuarios",
    subtitle: "Quién accede a Kevi Marketing.",
    add: "Agregar usuario",
    search: "Buscar por nombre o correo",
    columns: {
        user: "Usuario",
        contact: "Contacto",
        phone: "Teléfono",
        twofa: "Aut. 2FA",
        last_access: "Último acceso",
        actions: "Acciones",
    },
    twofa_on: "Activado",
    twofa_off: "Desactivado",
    no_email: "Sin correo",
    no_phone: "Sin teléfono",
    no_contact: "Sin correo ni teléfono.",
    unverified: "No verificado",
    unused: "Fuera de uso",
    tooltip_mkt: "Kevi Marketing. Esta persona accede a este producto.",
    tooltip_chat: "Kevi Chat. Esta persona también accede a Kevi Chat.",
    tooltip_email_pending: "Correo no verificado. Mientras esté pendiente, no sirve para restablecer la contraseña.",
    tooltip_phone_pending: "Teléfono no verificado. Mientras esté pendiente, no sirve para restablecer la contraseña.",
    tooltip_no_contact: "Sin correo y sin teléfono. Esta persona no puede restablecer su propia contraseña.",
    today: "Hoy {0}",
    yesterday: "Ayer {0}",
    never: "Nunca ingresó",
    empty: "Ningún usuario encontrado",
    empty_hint: "Agregue a quien va a acceder a Kevi Marketing.",
    empty_filters: "Nada coincide con estos filtros.",
    loading: "Cargando usuarios...",
    clear_filters: "Limpiar filtros",
    reload: "Recargar",
    load_error: "No fue posible cargar los usuarios.",
    load_error_hint: "La conexión falló. Intente de nuevo en un momento.",
    filters: {
        products: "Aplicaciones vinculadas",
        twofa: "Autenticación 2FA",
        contacts: "Contactos",
        marketing: "Kevi Marketing",
        chat: "Kevi Chat",
        email_verified: "Correo verificado",
        email_pending: "Correo pendiente",
        no_email: "Sin correo",
        phone_verified: "Teléfono verificado",
        phone_pending: "Teléfono pendiente",
        no_phone: "Sin teléfono",
    },
    menu: {
        edit_profile: "Editar perfil",
        edit_permissions: "Editar permisos",
        set_password: "Definir nueva contraseña",
        deactivate: "Desactivar usuario",
    },
    password_modal: {
        title: "Escriba su contraseña de administrador",
        subtitle: "Por seguridad, las acciones que afectan a otros usuarios piden su contraseña.",
        label: "Contraseña actual",
        close: "Cerrar",
        continue: "Continuar",
        submitting: "Validando...",
        wrong: "La contraseña de administrador no coincide.",
        failed: "No se pudo concluir. Intente de nuevo.",
        too_many: "Demasiados intentos con la contraseña. Espere unos minutos e inténtelo de nuevo.",
    },
    create: {
        title: "Crear usuario",
        step_user: "Usuario",
        step_permissions: "Permisos",
        name: "Nombre completo",
        searching: "Buscando usuarios similares...",
        found: "{0} usuarios similares encontrados",
        found_one: "1 usuario similar encontrado",
        none: "Ningún usuario encontrado",
        none_hint: "Cree un usuario nuevo con ese nombre.",
        failed_title: "No fue posible buscar",
        failed: "No se pudieron verificar usuarios similares. Aún puede crear uno nuevo y revisar después.",
        create_named: "Crear usuario {0}",
        existing: "Usuarios existentes",
        view_profile: "Ver perfil",
        link: "Vincular usuario",
        recover: "Recuperar usuario",
        import: "Importar usuario",
        linking: "Vinculando usuario · Kevi Chat > Kevi Marketing",
        photo_add: "Agregar foto",
        photo_change: "Cambiar foto",
        photo_edit: "Editar foto",
        username: "Usuario",
        username_placeholder: "Escriba un usuario válido",
        password: "Contraseña",
        repeat: "Repetir contraseña",
        email: "Correo",
        email_placeholder: "Escriba un correo para este usuario",
        phone: "Teléfono",
        phone_placeholder: "Escriba un teléfono para este usuario",
        product_marketing: "Acceso a Kevi Marketing",
        product_chat: "Acceso a Kevi Chat",
        yes: "Sí",
        no: "No",
        back: "Volver",
        next: "Siguiente",
        need_name: "Indique el nombre completo (mín. 3 caracteres).",
        need_username: "Indique un usuario válido (mín. 3 caracteres).",
        need_password: "Defina una contraseña con al menos 8 caracteres.",
        need_password_match: "La contraseña y la confirmación deben ser iguales.",
        submit: "Crear usuario",
        success: "¡Usuario creado con éxito!",
        linked: "¡Usuario vinculado con éxito!",
        linked_note: "El mismo usuario y contraseña valen para Kevi MKT y Kevi Chat.",
        no_contact_title: "¿Crear sin correo ni teléfono?",
        no_contact_body: "Sin un contacto, este usuario no podrá restablecer su propia contraseña.",
        continue_anyway: "Continuar de todos modos",
        another: "Crear otro",
        done: "Concluir",
        taken: "Este dato ya lo usa {0}. Vuelva a la búsqueda para vincular o recuperar.",
        permissions_title: "Permisos de Kevi Marketing",
        permissions_subtitle: "Controle el acceso a cobranza, gestión de usuarios y módulos de este producto.",
        billing: "Cobranza",
        billing_help: "Accede a cuenta, facturas, planes y pagos.",
        users: "Usuarios",
        users_help: "Gestiona usuarios y permisos de otras personas.",
        modules: "Módulos",
        linking_label: "Vinculando usuario",
        importing_label: "Importando usuario",
        recovering_label: "Recuperando usuario desactivado",
        back_to_search: "Volver a la búsqueda",
        reason_empty: "es obligatorio",
        reason_small: "es muy corto",
        reason_invalid: "es inválido",
        reason_taken: "ya está en uso",
    },
    edit: {
        title: "Editando usuario",
        load_error_title: "No fue posible cargar este usuario",
        load_error_body: "El perfil puede haber sido eliminado o la conexión falló. Intente de nuevo o vuelva a la lista.",
        permissions: "Editar permisos",
        password: "Editando contraseña",
        back: "Volver",
        save: "Cambiar",
        apply: "Aplicar",
        change_password: "Cambiar contraseña",
        new_password: "Escriba la nueva contraseña",
        repeat: "Repita la nueva contraseña",
        show: "Mostrar contraseña",
        hide: "Ocultar contraseña",
        contact_title: "Cambió los datos de un usuario activo",
        contact_body: "El usuario deberá confirmar los datos de contacto después de este cambio.",
        contact_back: "Volver",
        contact_continue: "Continuar de todos modos",
        sessions_title: "Cambió los datos de un usuario activo",
        sessions_body: "Si cierra la sesión, las sesiones abiertas terminan y la persona debe entrar con la nueva contraseña.",
        keep_sessions: "Guardar sin cerrar sesión",
        end_sessions: "Cerrar sesión en todos los dispositivos",
        toast_kept: "Contraseña cambiada. Las sesiones abiertas se mantuvieron.",
        toast_ended: "Contraseña cambiada. Los dispositivos cerraron sesión.",
        saved: "Cambios guardados.",
        taken_field: "Este {0} ya está en uso por otro usuario.",
    },
    deactivate: {
        title: "¿Desactivar usuario?",
        body: "El usuario pierde el acceso a Kevi Marketing de inmediato y deja de contar en el plan.",
        chat: "El acceso a Kevi Chat continúa. Para cerrarlo, desactívelo también allí.",
        cancel: "Cancelar",
        confirm: "Desactivar usuario",
        done: "Usuario desactivado",
        self: "No puede desactivar su propia cuenta.",
        protected: "Este usuario está protegido y no se puede cambiar aquí.",
        failed: "No fue posible desactivar. Inténtelo de nuevo.",
        last_admin: "La cuenta necesita al menos un usuario con el permiso Usuarios.",
        self_permission: "No puede quitar su propio permiso Usuarios.",
    },
    profile: {
        title: "Mi perfil",
        personal: "Datos personales",
        personal_help: "Cómo aparece su nombre para el equipo y en las conversaciones con clientes.",
        change: "Cambiar",
        security: "Seguridad",
        security_help: "Cómo recupera su cuenta y protege su acceso.",
        warning_title: "Agregue más protección a su cuenta",
        warning_body: "Complete los ítems pendientes. Garantizan que recupere el acceso solo y dejan la cuenta más segura.",
        recovery: "Formas de recuperación",
        recovery_help: "Enviamos el código de restablecimiento a los contactos verificados aquí.",
        verified: "Verificado",
        unverified: "No verificado",
        inactive: "Inactiva",
        active: "Activa",
        add_email: "Agregar correo",
        add_phone: "Agregar teléfono",
        change_email: "Cambiar correo",
        change_email_button: "Cambiar",
        verify: "Verificar",
        no_phone: "Ningún teléfono agregado",
        twofa: "Autenticación de dos factores",
        twofa_help: "Después de la contraseña, pedimos un código de la app autenticadora.\nProtege la cuenta aunque la contraseña se filtre.",
        enable: "Activar",
        disable: "Desactivar",
        password: "Contraseña",
        password_changed: "Cambiada el {0}.",
        password_unknown: "Cambie su contraseña cuando quiera.",
        change_password: "Cambiar contraseña",
        password_rule: "Use al menos 8 caracteres.",
        note: "Pedimos su contraseña actual siempre que cambia algo en esta pantalla.",
        logout_title: "Salir de la cuenta",
        logout_help: "Se cerrará la sesión solo en este dispositivo.",
        logout: "Salir",
        name_title: "Cambiar nombre",
        current_password: "Contraseña actual",
        cancel: "Cancelar",
        send_code: "Enviar código",
        your_email: "Su correo",
        confirm_email: "Confirme su correo",
        your_phone: "Su teléfono",
        confirm_phone: "Confirme su teléfono",
        add_email_help: "Enviamos un código para confirmar que el correo es suyo. Se usará para restablecer su contraseña.",
        add_phone_help: "Enviamos un código por SMS para confirmar que el teléfono es suyo. Se usará para restablecer su contraseña.",
        change_email_help: "El nuevo correo solo vale después de verificarse. Hasta entonces, el actual sigue usándose para la recuperación.",
        change_phone_help: "El nuevo teléfono solo vale después de verificarse. Hasta entonces, el actual sigue usándose para la recuperación.",
        code_title: "Escriba el código",
        code_help: "Enviamos un código de 6 dígitos a {0}.",
        code_sms: "Enviamos un código de 6 dígitos por SMS a {0}.",
        resend_in: "¿No lo recibió? Reenviar en {0}",
        resend: "Reenviar código",
        confirm: "Confirmar",
        invalid_code: "Código inválido o vencido. Pida un código nuevo.",
        email_toast: "Correo verificado",
        email_toast_body: "Ahora puede restablecer su contraseña por correo.",
        email_changed_toast: "Correo cambiado",
        email_changed_toast_body: "Ahora puede restablecer su contraseña con este correo.",
        phone_toast: "Teléfono verificado",
        phone_toast_body: "Ahora puede restablecer su contraseña por teléfono.",
        password_title: "Cambiar contraseña",
        new_password: "Nueva contraseña",
        repeat_password: "Repita la nueva contraseña",
        change_password_button: "Cambiar contraseña",
        password_toast: "Contraseña cambiada.",
        confirm_password_title: "Confirme su contraseña",
        confirm_password_help: "Para activar la autenticación de dos factores, confirme que es usted.",
        continue: "Continuar",
        qr_title: "Escanee el código QR",
        qr_step: "Paso 1 de 3",
        qr_help: "Abra su app autenticadora (Google Authenticator, Authy, 1Password) y escanee el código.",
        manual_key: "¿No puede escanear? Use la clave de abajo en su app.",
        copy: "Copiar",
        copied: "Copiado",
        code_step: "Paso 2 de 3",
        app_code: "Escriba el código de la app",
        app_code_help: "Informe los 6 dígitos que aparecen en su app autenticadora.",
        app_code_hint: "El código cambia cada 30 segundos.",
        app_code_error: "Código inválido o vencido. Inténtelo de nuevo.",
        activate: "Activar",
        codes_step: "Paso 3 de 3",
        codes_title: "Autenticación de dos factores activada",
        codes_help: "Guarde sus códigos de recuperación. Cada código funciona una vez y es la única forma de entrar si pierde la app.",
        copy_codes: "Copiar códigos",
        download: "Descargar .txt",
        saved_codes: "Guardé mis códigos",
        disable_title: "¿Desactivar la autenticación de dos factores?",
        disable_body: "Confirme su contraseña para desactivar.",
        disable_button: "Desactivar 2FA",
        disabled_title: "Autenticación de dos factores desactivada",
        disabled_body: "Solo la contraseña protege su cuenta ahora. Puede activar la autenticación de dos factores cuando quiera.",
        enable_again: "Activar autenticación 2FA de nuevo",
        close: "Cerrar",
        disabled_toast: "¡Autenticación 2FA desactivada!",
        disabled_toast_body: "Recomendamos activarla de nuevo cuanto antes.",
        wrong_password: "Contraseña incorrecta.",
        mismatch: "La contraseña y la confirmación no coinciden. Vuelva y revise los dos campos.",
        contact_mismatch: "Los campos de confirmación no coinciden. Revíselos e intente de nuevo.",
        invalid_phone: "Teléfono inválido. Use código de área + número.",
        send_failed: "No fue posible enviar el código. Intente de nuevo.",
        too_many: "Demasiados intentos. Espere unos minutos e intente de nuevo.",
        photo_saved: "Foto actualizada.",
        photo_failed: "No fue posible actualizar la foto. Intente de nuevo.",
        taken: "Este contacto ya está en uso.",
        disable_warning: "La cuenta vuelve a depender solo de la contraseña. Los códigos de recuperación dejan de funcionar.",
        change_phone: "Cambiar teléfono",
        verify_email: "Confirmar correo",
        verify_phone: "Confirmar teléfono",
        verify_email_help: "Enviaremos un código al correo registrado. Se usará para restablecer su contraseña.",
        verify_phone_help: "Enviaremos un código por SMS al teléfono registrado. Se usará para restablecer su contraseña.",
        phone_placeholder: "(99) 9 9999-9999",
        phone_changed_toast: "Teléfono cambiado",
        phone_changed_toast_body: "Ahora puede restablecer su contraseña con este nuevo teléfono.",
        name_help: "Así aparece su nombre para el equipo y en las conversaciones con clientes.",
        name_required: "Ingrese su nombre completo.",
        name_toast: "Nombre completo cambiado.",
        save: "Guardar",
        too_many_attempts: "Demasiados intentos con la contraseña. Espere unos minutos e inténtelo de nuevo.",
        generic_error: "No fue posible completar. Inténtelo de nuevo.",
        invalid_email: "Correo inválido. Revíselo e inténtelo de nuevo.",
        missing_contact: "No hay contacto registrado para confirmar.",
        code_expired: "El código venció. Solicite uno nuevo.",
        code_too_many: "Demasiados intentos con este código. Solicite uno nuevo.",
        twofa_restart: "Se acabó el tiempo para activar. Confirme su contraseña de nuevo.",
        twofa_too_many: "Demasiados intentos con el código. Confirme su contraseña y empiece de nuevo.",
        qr_alt: "Código QR para la app de autenticación",
    },
    prompt: {
        no_contact_title: "Su cuenta no puede recuperarse",
        no_contact_body: "Todavía no tiene correo ni teléfono verificado. Si olvida su contraseña, solo un administrador de su empresa puede restablecer el acceso.",
        email_title: "Confirme su correo",
        email_body: "El correo {0} fue registrado por su empresa, pero aún no fue confirmado. Hasta que lo confirme, solo un administrador puede restablecer su contraseña.",
        phone_title: "Confirme su teléfono",
        phone_body: "El teléfono {0} fue registrado por su empresa, pero aún no fue confirmado. Hasta que lo confirme, solo un administrador puede restablecer su contraseña.",
        add_phone: "Agregar teléfono",
        add_email: "Agregar correo",
        other_email: "Usar otro correo",
        confirm_email: "Confirmar correo",
        other_phone: "Usar otro teléfono",
        confirm_phone: "Confirmar teléfono",
        later: "Ahora no",
    },
};
